import React from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Footer from '../components/Footer';

const MainLayout = ({ children }) => {
    return (
        <div className="container-scroller">
            <Sidebar />
            <div className="container-fluid page-body-wrapper">
                <Header />
                <div className="main-panel">
                    {children}
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default MainLayout;